"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGameVendorSettings = fetchGameVendorSettings;
exports.gameVendorSettingsProviderSaga = gameVendorSettingsProviderSaga;
const effects_1 = require("redux-saga/effects");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/game-vendor-settings/api");
const slice_1 = require("./slice");
function* fetchGameVendorSettings() {
    try {
        const { data } = yield (0, effects_1.call)(api_1.getGameVendorSettings);
        yield (0, effects_1.put)(slice_1.gameVendorSettingsProviderActions.fetchGameVendorSettingsSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching  gameVendorSettings data', error);
        yield (0, effects_1.put)(slice_1.gameVendorSettingsProviderActions.fetchGameVendorSettingsError(error));
    }
}
function* gameVendorSettingsProviderSaga() {
    yield (0, effects_1.takeLatest)(slice_1.gameVendorSettingsProviderActions.fetchGameVendorSettings.type, fetchGameVendorSettings);
}
//# sourceMappingURL=saga.js.map